import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "replies__asset" }
const _hoisted_2 = { key: 1 }

import VAvatar from './VAvatar.vue';
import VCollapseContent from './VCollapseContent.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'AssetsCell',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as { items?: any[] }




return (_ctx: any,_cache: any) => {
  return (props.items && props.items.length > 0)
    ? (_openBlock(), _createBlock(VCollapseContent, {
        key: 0,
        height: 114,
        class: "assets-cell"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (acc) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(VAvatar, {
                src: acc.picture,
                type: acc.type_id
              }, null, 8, ["src", "type"]),
              _createTextVNode(_toDisplayString(acc.name), 1)
            ]))
          }), 256))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, "-"))
}
}

})